<div class="shopify_design">
  <div *ngIf="body.showConnectToSoreFromSetting">
    <h3>Connect your online workspace</h3>
    <form [formGroup]="ConnectForm" class="message-container">
      <!-- <div class="row" *ngIf="storesUrls.length && getControls['ChoosenShopUrl'].value !=='new-store'">
        <div class="col-md-9">
          <label>Shop URL</label>
          <mat-select placeholder="Choose Store or Create new " formControlName="ChoosenShopUrl" required disableRipple
            (selectionChange)="changeStoreUrlSelected($event)">
            <mat-option value="new-store"> New Store</mat-option>
            <mat-option *ngFor="let storeUrl of storesUrls" [value]="storeUrl">
              {{ storeUrl }}
            </mat-option>
          </mat-select>
        </div>
      </div> -->
      <div class="row">
        <ng-container *ngIf="body.platform==='shopify'">
          <div class="col-md-2 col-sm-2 col-xs-2"><span>https://</span></div>
          <div class="col-md-7 col-sm-7 col-xs-7" style="height: 69px;">
            <mat-form-field class="field-span">
              <input matInput placeholder="Workspace URL" formControlName="shopUrl" required>
              <!-- <mat-error *ngIf="shopUrl.length===0">URL is required</mat-error> -->
              <mat-error *ngIf="shopUrl.startsWith('https://') || shopUrl.endsWith('.myshopify.com')">URL must be valid
                without https://</mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-3 col-sm-3 col-xs-3">
            <span>.myshopify.com</span>
          </div>
        </ng-container>
        <ng-container *ngIf="body.platform==='custom'">

          <mat-form-field class="field-span">
            <input matInput [(ngModel)]="shopUrl" formControlName="shopUrl" type="text" placeholder="Title" required>
            <!-- <mat-error *ngIf="shopUrl.length===0">URL is required</mat-error> -->
            <!-- <mat-error *ngIf="shopUrl.startsWith('https://') || shopUrl.endsWith('.myshopify.com')">URL must be valid without https://</mat-error> -->
          </mat-form-field>

        </ng-container>
      </div>

      <div layout="row" layout-align="start none" class="button-menu">
        <button mat-raised-button color="primary" class="button-right" type="submit"
          (click)="ConnectStorewithSettingNew()">
          <span class="button-save">Connect your workspace </span>
        </button>
      </div>
    </form>
  </div>
</div>